import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: '30px 0',
    [theme.breakpoints.down('sm')]: {
      margin: '15px 0', 
    },
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column', 
      alignItems: 'center', 
    },
  },
  categoriesWrapper: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      margin: '0 0 20px ' 
    },
  },
  currencyField: {
    width: '145px',
    [theme.breakpoints.down('sm')]: {
      width: '100%', 
      margin: '0 0 20px ' 
    },
  },
  dropDownField: {
    marginBottom: '18px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '12px',
    },
  },
  helpIcon: {
    fontSize: '19px',
    marginTop: '27px',
    color: '#182e3d',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px', 
      marginTop: '20px', 
    },
  },
}));
